define('views/search/scope',[
  "backbone",
  "fancytree"
], function (Backbone) {
  "use strict";

  return Backbone.View.extend({
    initialize: function (options) {
      _.bindAll(this, "lazyload", "update", "select");
      this.options = options;
      this.model.on("change:scope", this.toggleState, this);
      this.model.on("reset", this.reset, this);
      this.render();
    },

    render: function () {
      this.$el.fancytree({
        select: this.select,
        icons: false,
        checkbox: true,
        selectMode: 3,
        keyPathSeparator: ".",
        source: { url: this.$el.data("source") },
        expand: function () { $(window).resize(); },
        extensions: ["dochub"],
        lazyLoad: this.lazyload
      });

      return this;
    },

    /**
     * Get the current scope.
     *
     * @returns {Array} A list of currently selected Fancytree nodes.
     */
    get: function () {
      return this.$el.fancytree("getTree").getSelectedNodes();
    },

    /*
     * Reset the scope.
     *
     * Enable silent mode before iterating over all selected nodes to prevent
     * the fancytreeselect event from firing. Otherwise Backbone will make
     * multiple server requests.
     *
     * @returns {Object} this.
     */
    reset: function () {
      this.silentMode = true;

      _.each(this.get(), function (node) {
        node.setSelected(false);
      });

      this.silentMode = false;
      this.model.unset("scope");
      return this;
    },

    /**
     * Update the scope.
     *
     * The search view listens to changes on the model, so setting the scope
     * attribute triggers in a request for a new set of search results with
     * the current scope applied.
     *
     * @returns {Object} this.
     */
    update: function () {
      var scope = _.map(this.get(), function (node) {
        return node.key;
      });

      if (scope.length) {
        this.model.set("scope", scope);
      } else {
        this.model.unset("scope");
      }

      return this;
    },

    toggle: function (duration) {
      this.$el.toggle(duration, function () {
        // Trigger a window resize event so that the search result element is
        // resized to match the current window height.
        $(window).resize();
      });

      return this;
    },

    select: function () {
      if (!this.silentMode) this.update();
      return this;
    },

    toggleState: function () {
      this.options.button.toggleClass("btn-info", this.model.has("scope"));
      return this;
    },

    lazyload: function (e, data) {
      var node = data.node;

      data.result = {
        url: this.$el.data("lazy"),
        data: {
          key: node.key,
          version: node.data.version,
          language: node.data.language
        }
      };
    }
  });
});

